import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getTopRatedComics } from '@/mocks/comics';

export default function RankingSection() {
  const { t } = useTranslation();
  const topComics = getTopRatedComics(10);

  const formatViews = (views: number): string => {
    if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
    return views.toString();
  };

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-8">
          {t('section.ranking')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {topComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 group"
            >
              <div className="flex-shrink-0 w-8 text-center">
                <span
                  className={`font-heading text-lg font-bold ${
                    index < 3 ? 'text-accent-500' : 'text-foreground-400'
                  }`}
                >
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>

              <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  title={comic.title}
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
              </div>

              <div className="flex-shrink-0 text-right">
                <div className="flex items-center gap-1 text-accent-500 justify-end">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-xs"></i>
                  </div>
                  <span className="text-xs font-semibold">{comic.rating}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{formatViews(comic.views)}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}